<template>
  <v-card height="800px" min-width="700px">
    <v-toolbar class="white--text" color="indigo" style="position: sticky; top: 0px; z-index: 1" dense>
      <v-toolbar-title>Calendario specifico</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5 mb-0 pb-5">
      <v-row align="center" justify="center">
        <v-col cols="4">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="
                dialog_giorni_sett = true;
              dialog_giorni_spec = false;
              dialog_giorni_ric = false;
              " v-bind="attrs" v-on="on" style="color: #0275d8">
                <v-icon class="mr-5">mdi-calendar</v-icon> Chiusura settimanale
              </v-btn>
            </template>
            <span> Chiusura settimanale</span>
          </v-tooltip>
        </v-col>
        <v-col cols="4">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="
                dialog_giorni_sett = false;
              dialog_giorni_spec = true;
              dialog_giorni_ric = false;
              " v-bind="attrs" v-on="on" style="color: #0275d8" class="ml-5">
                <v-icon class="mr-5">mdi-calendar-star</v-icon> Chiusura giorno specifico
              </v-btn>
            </template>
            <span>Chiusura giorno specifico</span>
          </v-tooltip>
        </v-col>
        <v-col cols="4">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="
                dialog_giorni_sett = false;
              dialog_giorni_spec = false;
              dialog_giorni_ric = true;
              " v-bind="attrs" v-on="on" style="color: #0275d8" class="ml-5">
                <v-icon class="mr-5">mdi-calendar-star</v-icon> Chiusura festività
              </v-btn>
            </template>
            <span>Chiusura festività</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <!-- GIORNI SETTIMANALI -->
      <v-card v-if="dialog_giorni_sett" max-width="800px" class="mt-5">
        <v-toolbar class="white--text" color="indigo" style="position: sticky; top: 0px; z-index: 1" dense>
          <v-toolbar-title>Giorni settimanali</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="aggiungiGiornoSett" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <h3 style="text-align: left">Chiusura settimanale</h3>
          <v-row>
            <v-col cols="4">
              <v-autocomplete :items="lista_giorni" label="Giorno" v-model="giorno"></v-autocomplete></v-col>
            <!-- <v-col cols="4"
              ><v-autocomplete
                :items="lista_ore"
                label="Dalle ore"
                v-model="ora_da"
              ></v-autocomplete
            ></v-col>
            <v-col cols="4"
              ><v-autocomplete
                :items="lista_ore"
                label="Alle ore"
                v-model="ora_a"
              ></v-autocomplete
            ></v-col> -->
            <v-col cols="3"><v-text-field type="time" placeholder="Da"
                class="mr-5" v-model="ora_da"></v-text-field></v-col>
            <v-col cols="3"><v-text-field type="time" placeholder="a"
                class="mr-5" v-model="ora_a"></v-text-field></v-col>
          </v-row>
          <v-row>
            <v-data-table height="60vh" style="width: 40vw; margin: auto" :headers="headers_eccezioni_sett"
              :items="lista_eccezioni_sett" fixed-header class="elevation-1 pt-0">
              <!-- Colonna del rimuovi -->
              <template v-slot:[`item.rimuovi`]="{ item }">
                <v-btn @click="
                  id_ecc_elimina = item.id_calendario_ecc;
                eliminaEccezione();
                " small v-model="item.rimosso"><v-icon color="error">mdi-delete</v-icon></v-btn>
              </template>
            </v-data-table>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- GIORNI SPECIFICI -->
      <v-card v-if="dialog_giorni_spec" max-width="800px" class="mt-5">
        <v-toolbar class="white--text" color="indigo" style="position: sticky; top: 0px; z-index: 1" dense>
          <v-toolbar-title>Giorni specifici</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaGiorniSpecifici" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <h3 style="text-align: left">Chiusura giornaliera</h3>
          <v-row align="center" justify="center">
            <v-col cols="3"><v-text-field type="date" placeholder="Giorno"
                class="mr-5" v-model="giorno_ecc"></v-text-field></v-col>
            <v-col cols="3"><v-text-field type="time" placeholder="Da"
                class="mr-5" v-model="da_ora_ecc"></v-text-field></v-col>
            <v-col cols="3"><v-text-field type="time" placeholder="a"
                class="mr-5" v-model="a_ora_ecc"></v-text-field></v-col>
            <!-- <v-col cols="6"
              ><template>
                <v-container class="ml-5" fluid>
                  <v-radio-group v-model="tipo_eccezione" row>
                    <v-radio disabled label="Presenza" value="1"></v-radio>
                    <v-radio label="Assenza" value="0"></v-radio>
                  </v-radio-group>
                </v-container> </template
            ></v-col> -->
          </v-row>
          <v-row>
            <v-data-table height="60vh" style="width: 40vw; margin: auto" :headers="headers_eccezioni_giorno"
              :items="lista_eccezioni_giorno" fixed-header class="elevation-1 pt-0">
              <!-- Colonna del rimuovi -->
              <template v-slot:[`item.rimuovi`]="{ item }">
                <v-btn @click="
                  id_ecc_elimina = item.id_calendario_ecc;
                eliminaEccezione();
                " small v-model="item.rimosso"><v-icon color="error">mdi-delete</v-icon></v-btn>
              </template>
            </v-data-table>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- GIORNI RICORRENTI -->
      <v-card v-if="dialog_giorni_ric" max-width="800px" class="mt-5">
        <v-toolbar class="white--text" color="indigo" style="position: sticky; top: 0px; z-index: 1" dense>
          <v-toolbar-title>Giorni ricorrenti</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaGiorniRicorrenti" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <h3 style="text-align: left">Chiusura giornaliera annuale</h3>
          <v-row align="center" justify="center"><v-col cols="3"><v-autocomplete :items="giorni" label="Giorno"
                v-model="giorno_ric_giorno"></v-autocomplete></v-col>
            <v-col cols="3"><v-autocomplete :items="mesi" label="Mese"
                v-model="giorno_ric_mese"></v-autocomplete></v-col>
            <v-col cols="4"><v-text-field type="text" label="Festività" class="mr-5"
                v-model="giorno_ric_des"></v-text-field></v-col>
          </v-row>
          <v-row>
            <v-data-table height="60vh" style="width: 80vw; margin: auto" :headers="headers_eccezioni_ric"
              :items="lista_eccezioni_ric" fixed-header class="elevation-1 pt-0">
              <!-- Colonna del rimuovi -->
              <template v-slot:[`item.rimuovi`]="{ item }">
                <v-btn @click="
                  eliminaEccezioneRic(item.id_calendario_festivita);
                " small v-model="item.rimosso"><v-icon color="error">mdi-delete</v-icon></v-btn>
              </template>
            </v-data-table>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card-text>
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import moment from "moment/moment";

export default {
  name: "",

  components: { SnackbarQV },

  props: ["id_riferimento", "visibilita", "tipo"],

  data() {
    return {
      // Variabili d'appoggio
      giorno: "",
      giorno_ecc: "",
      da_ora_ecc: "",
      a_ora_ecc: "",
      giorno_ric_mese: "",
      giorno_ric_giorno: "",
      giorno_ric_des: "",
      ora_da: "",
      ora_a: "",
      id_ecc_elimina: null,
      // Modal
      dialog_giorni_sett: false,
      dialog_giorni_spec: false,
      dialog_giorni_ric: false,

      // Array

      lista_giorni: [
        "Lunedì",
        "Martedì",
        "Mercoledì",
        "Giovedì",
        "Venerdì",
        "Sabato",
        "Domenica",
      ],
      lista_ore: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        20, 21, 22, 23, 24,
      ],

      giorni: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],

      mesi: [
        "Gennaio",
        "Febbraio",
        "Marzo",
        "Aprile",
        "Maggio",
        "Giugno",
        "Luglio",
        "Agosto",
        "Settembre",
        "Ottobre",
        "Novembre",
        "Dicembre",
      ],

      headers_eccezioni: [],
      headers_eccezioni_ric: [],
      lista_eccezioni: [],
      lista_eccezioni_sett: [],
      lista_eccezioni_giorno: [],
      lista_eccezioni_ric: [],
    };
  },

  computed: {},

  watch: {
    id_riferimento() {
      console.log(this.id_riferimento);
      this.getGiorniSpecifici();
    },

    visibilita() {
      //console.log(this.id_riferimento);
      if (this.visibilita == true) {
        this.getGiorniSpecifici();
      } else console.log(this.visibilita);
    },
  },

  methods: {
    aggiungiGiornoSett() {
      // Conversione giorno
      let giorno_num = null;

      switch (this.giorno) {
        case "Lunedì":
          giorno_num = 1;
          break;
        case "Martedì":
          giorno_num = 2;
          break;
        case "Mercoledì":
          giorno_num = 3;
          break;
        case "Giovedì":
          giorno_num = 4;
          break;
        case "Venerdì":
          giorno_num = 5;
          break;
        case "Sabato":
          giorno_num = 6;
          break;
        case "Domenica":
          giorno_num = 7;
          break;
      }

      const request = {
        controller: "Tools",
        method: "PUT",
        richiesta: {
          action: "seteccezioni",
          token: localStorage.getItem("user_token"),
          eccezione: {
            id_calendario_ecc: -1,
            rif_calendario: this.id_riferimento,
            validita: 1,
            da_data: "0001-01-01 " + this.ora_da,
            a_data: "0001-01-01 " + this.ora_a,
            tipo: this.tipo,
            giorno_settimana: giorno_num,
          },
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.$refs.SnackbarQV.print("success", `Salvataggio effettuato.`);
          this.getGiorniSpecifici();
          this.giorno = "";
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      })
        .catch((e) => {
          this.$refs.SnackbarQV.print(
            "error",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
          console.log(e);
        });
    },

    clickChiudi() {
      this.dialog_giorni_sett = false;
      this.dialog_giorni_spec = false;
      this.giorno = "";
      this.$emit("click_chiudi");
    },

    eliminaEccezione() {
      const request = {
        controller: "Tools",
        method: "PUT",
        richiesta: {
          action: "seteccezioni",
          token: localStorage.getItem("user_token"),
          eccezione: {
            id_calendario_ecc: this.id_ecc_elimina,
            validita: 0,
            tipo: this.tipo,
          },
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.getGiorniSpecifici();
          this.id_calendario_ecc = null;
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      })
      .catch((e) => {
          this.$refs.SnackbarQV.print(
            "error",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
          console.log(e);
        });
    },

    eliminaEccezioneRic(id_elim) {


      const request = {
        controller: "Tools",
        method: "PUT",
        richiesta: {
          action: "setcalendariofestivita",
          token: localStorage.getItem("user_token"),
          festivita: {
            id_calendario_festivita: id_elim,
            validita: 0,
          },
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.$refs.SnackbarQV.print("success", `Salvataggio effettuato.`);
          this.getGiorniRic();
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },

    getGiorniRic() {
      this.headers_eccezioni_ric = [
        {
          text: "Giorno",
          value: "giorno",
        },
        {
          text: "Festività",
          value: "descrizione",
        },
        {
          text: "Rimuovi",
          value: "rimuovi",
        },
      ];

      this.lista_eccezioni_ric = [];

      const data = moment();
      const anno = data.year();

      const request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "getcalendariofestivita",
          token: localStorage.getItem("user_token"),
          anno: anno,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.lista_eccezioni_ric = res.data.calendario_festivita
            ? res.data.calendario_festivita
            : [];

            this.lista_eccezioni_ric.forEach((le) =>{

              le.giorno = le.giorno.split("-")[1] + "-" + le.giorno.split("-")[2];
            });


          console.log(this.lista_eccezioni_ric);
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },

    getGiorniSpecifici() {
      console.log("id_riferimento ==>", this.id_riferimento);
      this.headers_eccezioni_giorno = [
        {
          text: "Da ",
          value: "da_data",
        },
        {
          text: "A",
          value: "a_data",
        },
        {
          text: "Rimuovi",
          value: "rimuovi",
        },
      ];

      this.headers_eccezioni_sett = [
        {
          text: "Giorno",
          value: "giorno_settimana",
        },
        {
          text: "Da ",
          value: "da_ora",
        },
        {
          text: "A",
          value: "a_ora",
        },
        {
          text: "Rimuovi",
          value: "rimuovi",
        },
      ];

      this.lista_eccezioni_sett = [];
      this.lista_eccezioni_giorno = [];

      const request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "geteccezioni",
          token: localStorage.getItem("user_token"),
          rif_calendario: this.id_riferimento,
          tipo: this.tipo,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.lista_eccezioni = res.data.calendario_ecc
            ? res.data.calendario_ecc
            : [];
          console.log(this.lista_eccezioni);

          this.lista_eccezioni.forEach((e) => {
            if (e.da_data != null && e.giorno_settimana == null) {
               console.log(e.da_data.split("T")[0]);
              e.formato_data = new Date(e.da_data.split(" ")[0]);
              e.da_data = this.formatDataOra(e.da_data);
              e.a_data = this.formatDataOra(e.a_data);
              console.log(e.da_data);
              console.log(e.a_data);
              this.lista_eccezioni_giorno.push(e);
             
            }

            this.lista_eccezioni_giorno.sort((a, b) => b.formato_data.getTime() - a.formato_data.getTime());

            if (e.giorno_settimana != null) {
              switch (e.giorno_settimana) {
                case 1:
                  e.giorno_settimana = "Lunedì";
                  break;
                case 2:
                  e.giorno_settimana = "Martedì";
                  break;
                case 3:
                  e.giorno_settimana = "Mercoledì";
                  break;
                case 4:
                  e.giorno_settimana = "Giovedì";
                  break;
                case 5:
                  e.giorno_settimana = "Venerdì";
                  break;
                case 6:
                  e.giorno_settimana = "Sabato";
                  break;
                case 7:
                  e.giorno_settimana = "Domenica";
                  break;
              }

              e.da_ora = this.formatDataOra(e.da_data).split(" ")[1];
              e.a_ora = this.formatDataOra(e.a_data).split(" ")[1];
              this.lista_eccezioni_sett.push(e);
            }
          });
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },

    formatData(data) {
      if (data != null) {
        data = data.split("T");
        return data == null || data[0] == ""
          ? "N/D"
          : moment(data[0]).format("DD-MM-YYYY");
      }
    },
    formatDataOra(arg) {
  let date = moment(arg);

  // Verifica se la data è valida
  if (!date.isValid()) {
    return "";  // Restituisce una stringa vuota se la data è invalida
  }

  let formattedDate = date.format("DD/MM/YYYY");
  let hours = date.format("HH:mm");

  return formattedDate + " " + hours;
},

    salvaGiorniRicorrenti() {

      for (let i = 0; i < this.mesi.length; i++) {
        if (this.giorno_ric_mese == this.mesi[i]) {
          this.giorno_ric_mese = i + 1;
        }
      }

      const request = {
        controller: "Tools",
        method: "PUT",
        richiesta: {
          action: "setcalendariofestivita",
          token: localStorage.getItem("user_token"),
          festivita: {
            id_calendario_festivita: null,
            giorno: this.giorno_ric_mese + "-" + this.giorno_ric_giorno,
            descrizione: this.giorno_ric_des,
          },
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.$refs.SnackbarQV.print("success", `Salvataggio effettuato.`);
          this.giorno_ric_mese = "";
          this.giorno_ric_giorno = "";
          this.giorno_ric_des = "";
          this.getGiorniRic();
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },

    salvaGiorniSpecifici() {
      const request = {
        controller: "Tools",
        method: "PUT",
        richiesta: {
          action: "seteccezioni",
          token: localStorage.getItem("user_token"),
          eccezione: {
            id_calendario_ecc: -1,
            rif_calendario: this.id_riferimento,
            validita: 1,
            tipo: this.tipo,
            da_data: this.giorno_ecc + " " + this.da_ora_ecc,
            a_data: this.giorno_ecc  + " " + this.a_ora_ecc,
            numero_ore: 24,
          },
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.$refs.SnackbarQV.print("success", `Salvataggio effettuato.`);
          this.getGiorniSpecifici();
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      })
      .catch((e) => {

          this.$refs.SnackbarQV.print(
            "error",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
          console.log(e);
        });
    },
  },

  created() { },

  mounted() {
    this.getGiorniSpecifici();
    this.getGiorniRic();
  },
};
</script>

<style scoped></style>